import { axiosApi } from 'shared/api/axios'
import { CounterpartiesEndpoint } from 'entities/counterparties/api/constant'

export const deleteContactToCounterparty = async (id: number) => {
    try {
        await axiosApi.delete(`${CounterpartiesEndpoint.contact}/${id}`)
    } catch (err) {
        console.error(err)
        throw new Error('Ошибка')
    }
}
